export default {
  fraud: {
    fraud: "Fraud",
    map: "Map",
    caseSummary: "Case Summary",
    workflow: "Workflow",
    caseDetail: "Case Detail",
    networkInformation: "Network Information",
    investigationWorkbench: "Investigation Workbench",
    investigationHistory: "Investigation History",
    groupType: "Group Type"
  }
};
